import { CoreRankingsHeader } from '../../../views';
import teamplate from './index.jst';
import pre_season_teamplate from './pre_season_teamplate.jst';
import './index.styl';

const start_round_streak = process.env.START_ROUND_STREAK;

/**
 * @desc Rankings Streak Header Class
 * This class using on rankings page ('rankings/streak')
 */
export class RankingsHeaderStreak extends CoreRankingsHeader {
	get className() {
		return "rankings-header-streak";
	}

	get template() {
		let actual_round = this.rounds.actual;

		if(
			actual_round &&
			actual_round.get('id') < start_round_streak
		) {
			return pre_season_teamplate;
		}
		else {
			return teamplate;
		}
	}
}

export default RankingsHeaderStreak;